/* global angular, $ */
angular.module('ua5App')
    .directive('scatterPost', ['$state', '$rootScope', '$analytics', function($state, $rootScope, $analytics) {
        return {
            restrict: 'E',
            templateUrl: 'components/scatter_post/scatter_post.html',
            scope: {
                posts: '='
            },
            link: function($scope, $element, $attrs) {
                var $$imageHolder = $($element).find('.scatter-post__content');
                var $$pannableDiv = $$imageHolder.PannableDiv();
                var $$randomLayout;
                var termsLoaded = false;
                var swarmTimeout;
                var blinkTimeout;
                $rootScope.$broadcast('showLoader');
                $rootScope.loadingScatterPost = true;

                // Listen to LAYOUT_COMPLETE event, fired when jquery.arrange is completely done
                $$imageHolder.bind('LAYOUT_COMPLETE', function(event, data) {

                    //-- if logo preloader has already shown…
                    if ($rootScope.hasRevealedLogo) {
                        showContainerAndTerms($$imageHolder);
                    }

                    //-- only add the terms first time around
                    if (!termsLoaded) {
                        $$imageHolder.FloatingTerms({
                            data: $scope.posts
                        });
                        termsLoaded = true;
                    }

                    $scope.$on('logoAnimationComplete', function() {
                        showContainerAndTerms($$imageHolder);

                        $$imageHolder.on('click', function(e) {
                            // Clicked in white space
                            if (e.target === this) {
                                // If on index go to search, otherwise go back to
                                // index.
                                if ($state.current.name === 'index') {
                                    //-- Don't show search on touch screens
                                    if (!window.Modernizr.touch) {
                                        $state.go('index.search');
                                    }
                                } else {
                                    $state.go('index');
                                }
                            }
                        });

                    });

                    //$$imageHolder.data('RandomLayout').start();

                    $rootScope.$broadcast('expandLogo');
                    $$pannableDiv.enable();
                    $rootScope.$broadcast('landingLayoutComplete');
                });

                clearInterval(blinkTimeout);
                blinkTimeout = setInterval(function() {
                    $element.find('.scatter-post').toggleClass('scatter-post--blink');
                }, 500);

                // Go to artist when image is clicked. Deep linked to image.
                $$imageHolder.bind('ITEM_CLICKED', function(e, item) {
                    $state.go('index.artist', {
                        index: $(item).data('imageIndex'),
                        artist: $(item).data('slug')
                    });
                    $$pannableDiv.pause();
                });

                // Go to tag page when clicked
                $$imageHolder.bind('TAG_CLICKED', function(e, item) {
                    $analytics.eventTrack('Click', {
                        category: 'Microsite Storylines | Discovery',
                        label: $(item).data('terms')
                    });
                    $state.go('index.tag', {
                        tag: $(item).data('terms')
                    });
                    $$pannableDiv.pause();
                });

                $scope.$on('$stateChangeSuccess', function() {
                    $$pannableDiv.pause();
                });

                function showContainerAndTerms($$imageHolder) {
                    var TERMS_DELAY = 500;

                    $$imageHolder.data('RandomLayout').show();

                    if (window.Modernizr.touch) {
                        window.ih = $$imageHolder;
                        $$imageHolder.parent().scrollTop($$imageHolder.height() / 2);
                        $$imageHolder.parent().scrollLeft($$imageHolder.width() / 2);
                    }

                    setTimeout(function() {
                        $$imageHolder.find('.rand-img__link').unbind('mouseenter');
                        $$imageHolder.find('.rand-img__link').unbind('mouseleave');
                        $$imageHolder.find('.rand-img__link').on('mouseenter', function(e) {
                            var $ihSelf = $(this);

                            clearTimeout(swarmTimeout);
                            swarmTimeout = setTimeout(function() {
                                $ihSelf.addClass('rand-img__hovered');
                                //$rootScope.$broadcast('pingLogo');
                                $$imageHolder.data('FloatingTerms').swarm(e);
                            }, 400);
                        });

                        $$imageHolder.find('.rand-img__link').on('mouseleave', function(e) {
                            var $ihSelf = $(this);
                            //$rootScope.$broadcast('unpingLogo');
                            clearTimeout(swarmTimeout);
                            $ihSelf.removeClass('rand-img__hovered');
                            $$imageHolder.data('FloatingTerms').unswarm(e);
                        });

                    }, TERMS_DELAY);
                }

                //$$imageHolder.PannableDiv();
                $$randomLayout = $$imageHolder.RandomLayout({
                    data: $scope.posts
                });

                $$imageHolder.bind('IMAGES_LOADED', function() {
                    $rootScope.$broadcast('hideLoader');
                    $rootScope.loadingScatterPost = false;
                    if (!$rootScope.hasRevealedLogo) {
                        //-- Size the boxes now that the logo is paused
                        $scope.$on('finishLogoAnimationComplete', function() {
                            $$randomLayout.pack();
                        });

                        $rootScope.$broadcast('finishLogoAnimation');
                    } else {
                        $$randomLayout.pack();
                    }
                });

                // Cleanup
                $scope.$on('$destroy', function() {
                    $$imageHolder.off();
                    $$imageHolder.data('RandomLayout').destroy();
                    $$pannableDiv.destroy();
                    clearInterval(blinkTimeout);
                });
            }
        };
    }])
;
